import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';

export const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {}, setTheme: () => {} });

export function ThemeProvider({ children, defaultTheme = undefined }){
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'dark';
    return defaultTheme || localStorage.getItem('theme') || 'dark';
  });

  // Apply theme to document.body and persist
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (theme === 'light') document.body.classList.add('light');
    else document.body.classList.remove('light');
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('theme', theme);
    }
  }, [theme]);

  // Toggle returns the new theme (computed from current value)
  const toggleTheme = useCallback(() => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    return next;
  }, [theme]);

  // Sync cross-tabs if another tab changes localStorage
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onStorage = (e) => {
      if (e.key === 'theme' && e.newValue) setTheme(e.newValue);
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const value = useMemo(() => ({ theme, setTheme, toggleTheme }), [theme, toggleTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}
